import { useTranslation } from 'react-i18next'

import LinkIcon from '@wwt/shared/assets/icons/outline/share.svg'

import { NestedMenuItem } from '@/shared/ui/NestedMenu'

import { useCopyLink } from '../../lib/useCopyLink'
import { ShareLink } from './ShareLink'

export const CopyLink = () => {
	const { t } = useTranslation('header')

	const { isCopied, handleLinkShare } = useCopyLink()

	return (
		<ShareLink
			icon={<LinkIcon />}
			data-wwt-id="header__share-copy--button"
			text={isCopied ? t('share.options.copied') : t('share.options.copyLink')}
			onShare={handleLinkShare}
		/>
	)
}

export const CopyLinkItem = () => {
	const { t } = useTranslation('header')

	const { isCopied, handleLinkShare } = useCopyLink()

	return (
		<NestedMenuItem
			data-wwt-id="header__burger-share-copy--button"
			onClick={handleLinkShare}
		>
			<LinkIcon />
			{isCopied ? t('share.options.copied') : t('share.options.copyLink')}
		</NestedMenuItem>
	)
}
